import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import { Link } from "react-router-dom";

import "./NotFoundPage.css";

export default function NotFoundPage() {
  useSourceLanguage();
  return (
    <main className="seo-not-found" id="main-content">
      <span aria-hidden="true">404</span>
      <p><LocalizedText source={"Cette page n’existe pas ou n’est plus disponible."} /></p>
      <h1><LocalizedText source={"Retrouvons le bon chemin"} /></h1>
      <div>
        <Link to="/"><LocalizedText source={"Retour à l’accueil"} /></Link>
        <Link to="/market"><LocalizedText source={"Explorer les univers"} /></Link>
      </div>
    </main>
  );
}
